import { render, staticRenderFns } from "./SalSob.vue?vue&type=template&id=40681c82&scoped=true&"
import script from "./SalSob.vue?vue&type=script&lang=js&"
export * from "./SalSob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40681c82",
  null
  
)

export default component.exports